import React from 'react';
import { createPortal } from 'react-dom';
import { Phone, MessageCircle } from 'lucide-react';

const PHONE = '+33674626368';
const PHONE_DISPLAY = '+33 6 74 62 63 68';
const WHATSAPP_URL = 'https://wa.me/33674626368?text=Bonjour%2C%20je%20souhaite%20r%C3%A9server%20un%20taxi%20Yellow%20Cab%20Corsica.';

const MobileCallBar = () => {
  const bar = (
    <div
      data-testid="mobile-call-bar"
      className="md:hidden bg-[#0D0D0D] border-t border-white/10 shadow-2xl"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9998,
        transform: 'translateZ(0)',
        WebkitTransform: 'translateZ(0)',
      }}
    >
      <div className="flex gap-2 px-3 py-2.5">
        <a
          href={`tel:${PHONE}`}
          data-testid="mobile-call-bar-btn"
          className="flex-1 flex items-center justify-center gap-2 bg-[#EAB308] hover:bg-[#CA8A04] text-black font-bold py-3 rounded-xl text-sm transition-colors active:scale-95"
          aria-label="Appeler Yellow Cab Corsica"
        >
          <Phone size={16} />
          {PHONE_DISPLAY}
        </a>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-call-bar-whatsapp-btn"
          className="flex-1 flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold py-3 rounded-xl text-sm transition-colors active:scale-95"
          aria-label="Contacter via WhatsApp"
        >
          <MessageCircle size={16} />
          WhatsApp
        </a>
      </div>
    </div>
  );

  return createPortal(bar, document.body);
};

export default MobileCallBar;
